module.exports = __webpack_public_path__ + "img/EY__bg_xl.715f7999.png";